{
  "title": "Mines",
  "subtitle": "Avoid the mines, more crystals mean higher multipliers",
  "connecting": "Connecting…",
  "connected": "Connected",
  "reconnecting": "Reconnecting…",
  "unauthorized": "Unauthorized",
  "authFailed": "Login failed",
  "retryLogin": "Retry Connection",
  "backLobby": "Lobby",
  "lobby": "Lobby",
  "balance": "Balance {{amount}}",
  "bet": "Amount",
  "mineCount": "Mines",
  "half": "1/2",
  "max": "Max",
  "quickChips": "Quick chips",
  "close": "Close",
  "start": "Start Round",
  "restoringRound": "Checking for an active round…",
  "restoreFailed": "We could not verify the current round, so betting is paused to prevent a duplicate wager",
  "actionOutcomeUnknown": "The action result could not be confirmed. Check the current round before continuing.",
  "restoreBalanceFailed": "No active round was found, but the balance could not be refreshed. Try the recovery check again.",
  "retryRestore": "Check Round Again",
  "balanceRefreshFailed": "Action completed; balance is temporarily unavailable",
  "retryBalance": "Refresh Balance",
  "refreshingBalance": "Refreshing Balance…",
  "multiplier": "Multiplier",
  "nextCell": "Next",
  "opened": "Opened",
  "roundSummary": "{{mines}} mines · {{opened}} safe opened",
  "cashout": "Cash Out {{amount}}",
  "cashedHint": "Cashed out · Multiplier {{mult}}x · Payout {{payout}}",
  "bombed": "Hit a mine! Round ended.",
  "again": "Play Again",
  "rules": "Rules",
  "rulesTitle": "How to Play Mines",
  "rulesBody": "A 5x5 grid hides the selected number of mines. Each safe crystal you reveal increases the payout multiplier. You can cash out anytime before hitting a mine.",
  "cellHidden": "Cell {{n}}",
  "cellMine": "Mine {{n}}",
  "cellSafe": "Safe {{n}}",
  "startFailed": "Start failed",
  "openFailed": "Reveal failed",
  "cashFailed": "Cashout failed",
  "errors": {
    "insufficient_funds": "Insufficient funds",
    "user_not_found": "User not found",
    "no_active_round": "No active round",
    "round_ended": "Round ended",
    "cell_opened": "Cell already opened",
    "open_safe_first": "Open at least one safe cell first",
    "busy": "Action in progress",
    "invalid_bet": "Invalid bet amount",
    "invalid_mines": "Invalid mine count",
    "invalid_cell": "Invalid cell",
    "unauthorized": "Please log in",
    "unknown": "An error occurred"
  }
}
